import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from '~/axios';
import { connect } from 'react-redux';
import { logIn } from '../reducers/index';
import { Form, Icon, Input, Button, Row, Col, Alert } from 'antd';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

// make redux state and dispatch available as properties
const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = dispatch => {
    return {
        logIn: user => dispatch(logIn(user))
    };
};

//If there is a login error, display login component
function LoginErrorAlert(props) {
    if (props.loginError) return (
        <div>
            <Alert message={ props.loginError } type="error"/>
            <br/>
        </div>
    );
    else return null;
}

class ConnectedLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            remember: '',
            loginError: undefined
        };
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    // note: this page is not using the ant design way of submitting forms
    onInputChange(event) {
        const target = event.target;
        const name = target.name;
        const id = target.id;
        const value = target.type === 'checkbox'
            ? target.checked
            : target.value;
        this.setState({ [id]: value });
        this.props.form.setFieldsValue({
            [id]: value,
        });
    }

    async onFormSubmit(event) {
        event.preventDefault();
        const { email, password } = this.state;
        try {
            const response = await axios.post('/oauth/token', {
                grant_type: 'password',
                username: email,
                password: password,
                client_id: process.env.MIX_PASSWORD_CLIENT_ID,
                client_secret: process.env.MIX_PASSWORD_CLIENT_SECRET
            });
            if (response) {
                sessionStorage.setItem("access_token", response.data.access_token);
                sessionStorage.setItem("refresh_token", response.data.refresh_token);
                this.props.logIn({ username: email, access_token: response.data.refresh_token });
            }
        } catch ( error ) {
            console.dir(error.response.data);
            let errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : "Unknown Error"
            this.setState({ loginError: errorMessage })
        }
    }


    render() {
        // initialize a variable to store where the user came from
        let from = '';
        if (typeof this.props.location.state !== 'undefined') {
            // user came from somewhere
            from = this.props.location.state.referrer;
        } else {
            // user came from nowhere
            from = "/";
        }

        // if the user is already authenticated, redirect them back to where they came from
        if (this.props.isAuthenticated) {
            return <Redirect to={ from }/>
        }

        // bind the state to constants
        const { email, password } = this.state;

        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;

        // only show an error after a field is touched
        const emailError = isFieldTouched('email') && getFieldError('email');
        const passwordError = isFieldTouched('password') && getFieldError('password');

        return (<div>

            <Row type="flex" justify="center">
                <Col span={ 12 } xs={ 24 } md={ 12 } lg={ 8 }>
                    <LoginErrorAlert loginError={ this.state.loginError }/>
                    <h1>Log In</h1>

                    <Form onSubmit={ this.onFormSubmit }>
                        <Form.Item validateStatus={ emailError ? 'error' : '' } help={ emailError || '' }>
                            { getFieldDecorator('email', {
                                rules: [{ required: true, message: 'Please enter your email.' }],
                            })(
                                <Input prefix={ <Icon type="user" style={ { color: 'rgba(0,0,0,.25)' } }/> }
                                       placeholder="Email" onChange={ this.onInputChange }/>
                            ) }
                        </Form.Item>

                        <Form.Item validateStatus={ passwordError ? 'error' : '' } help={ passwordError || '' }>
                            { getFieldDecorator('password', {
                                rules: [{ required: true, message: 'Please enter your password.' }],
                            })(
                                <Input prefix={ <Icon type="lock" style={ { color: 'rgba(0,0,0,.25)' } }/> }
                                       type="password" placeholder="Password" onChange={ this.onInputChange }/>
                            ) }
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" disabled={ hasErrors(getFieldsError()) }>
                                Log In
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>

        </div>);
    }
}

// create the form as an ant design form
const LoginForm = Form.create()(ConnectedLogin);
// connect the login form to redux
const Login = connect(mapStateToProps, mapDispatchToProps)(LoginForm);
export default Login;
